import React, { useId } from 'react';
import { Box } from '@mui/material';

/**
 * BaigLabs emblem — abstract “lab platforms” mark (no letterforms).
 * Three ascending modules in a seal: research stacked into products.
 */
function BaiglabsLogo({ size = 32 }) {
  const uid = useId().replace(/:/g, '');
  const g = `bl-${uid}`;

  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
      aria-hidden
    >
      <defs>
        <linearGradient id={`${g}-bg`} x1="10" y1="6" x2="54" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#082f4d" />
          <stop offset="0.55" stopColor="#0d4a75" />
          <stop offset="1" stopColor="#1a6bb5" />
        </linearGradient>
      </defs>

      <circle cx="32" cy="32" r="30" fill={`url(#${g}-bg)`} />
      <circle cx="32" cy="32" r="25" stroke="rgba(255,255,255,0.22)" strokeWidth="1.25" fill="none" />

      {/* Ascending lab platforms — left-aligned stack, widening upward in presence */}
      <g fill="#fff">
        <rect x="18" y="38" width="28" height="5.5" rx="1.75" opacity="0.92" />
        <rect x="21" y="29.25" width="22" height="5.5" rx="1.75" opacity="0.92" />
        <rect x="24" y="20.5" width="16" height="5.5" rx="1.75" opacity="0.92" />
      </g>
      {/* Quiet connector — continuity across platforms */}
      <rect x="30.75" y="20.5" width="2.5" height="23" rx="1.25" fill="#fff" opacity="0.35" />
    </Box>
  );
}

export default BaiglabsLogo;
